import React from 'react';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import SettingsSection from './settings-section';

const LanguageSettingsSection = ({
  languages,
  selectedLanguage,
  onLanguageChange,
  onSave,
}) => {
  const { t } = useTranslation();

  return (
    <SettingsSection title={t('language-settings-title')}>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <div className="form-control">
            <select
              className="normal"
              value={selectedLanguage}
              onChange={(event) => onLanguageChange(event.target.value)}
            >
              {languages.map(({ code, name }) => (
                <option key={code} value={code}>{name}</option>
              ))}
            </select>
          </div>
        </Grid>
      </Grid>
      <div className="actions">
        <button
          className="btn"
          type="button"
          onClick={onSave}
          disabled={languages.length === 0}
        >
          {t('common-save-changes')}
        </button>
      </div>
    </SettingsSection>
  );
};

export default LanguageSettingsSection;
